export default "__VITE_ASSET__CwNsKg4y__"